import { TreeStations, Users } from '@/Interface/user';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '@services/utility.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PlantList } from '@/Interface/plantList';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LinkPlantUser } from '@/Interface/linkPlantUser';
import Swal from 'sweetalert2';
import { PlantByUser } from '@/Interface/plantByUser';
import { RemoveLinkUser } from '@/Interface/removePlantUser';
import { UserProfile } from '@/Interface/userProfile';
import { ToastrService } from 'ngx-toastr';
import { catchError, debounceTime, finalize, tap } from 'rxjs/operators';
import { of, Subject, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AccountType } from '@/Interface/userType';
import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { PermissionsService } from '@services/permissions.service';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition(
                'expanded <=> collapsed',
                animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
            )
        ])
    ]
})
export class UserListComponent implements OnInit {
    selectedUserId: number;
    constructor(
        private modalService: NgbModal,
        private _utilityService: UtilityService,
        private _utiltiySevice: UtilityService,
        private formBuilders: FormBuilder,
        private toaster: ToastrService,
        private permService: PermissionsService,

    ) {
        this.userList = this.formBuilders.group({
            full_name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]*$')]],
            contact: ['', [Validators.pattern('[0-9]*'), Validators.minLength(11), Validators.maxLength(11)]],
            username: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]],
            employee_id: [''],
            cnic: ['', [Validators.required, Validators.pattern('^[0-9]{5}-[0-9]{7}-[0-9]{1}$')]],
            user_type: [null, [Validators.required]],
            role: [null, [Validators.required]],
            is_active: [true]
        });
        this.userEditForm = this.formBuilders.group({
            full_name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]*$')]],
            contact: ['', [Validators.pattern('[0-9]*'), Validators.minLength(11), Validators.maxLength(11)]],
            username: [{ value: null, disabled: true }],
            email: [{ value: null, disabled: true }],
            employee_id: [''],
            cnic: ['', [Validators.required, Validators.pattern('^[0-9]{5}-[0-9]{7}-[0-9]{1}$')]],
            user_type: [null, [Validators.required]],
            role: [null, [Validators.required]],
            is_active: [true]
        });
        this.viewUserForm = this.formBuilders.group({
            full_name: [{ value: null, disabled: true }],
            contact: [{ value: null, disabled: true }],
            username: [{ value: null, disabled: true }],
            email: [{ value: null, disabled: true }],
            employee_id: [{ value: null, disabled: true }],
            cnic: [{ value: null, disabled: true }],
            user_type: [{ value: null, disabled: true }],
            role: [{ value: null, disabled: true }],
            is_active: [{ value: null, disabled: true }]
        });

        // Subscribe to user type changes to dynamically load roles
        this.userList.get('user_type').valueChanges.subscribe(typeId => {
            this.onUserTypeChange(typeId);
        });

        this.userEditForm.get('user_type').valueChanges.subscribe(typeId => {
            this.onUserTypeChangeEdit(typeId);
        });
    }
    @ViewChild('search', { static: false }) search: any;
    userTypelist: AccountType[];
    pageSize: number;
    pageToGo: number = 1;
    searchElement = '';
    serialNumberArray: Array<number> = [];
    next_page: number;
    current_page: number;
    previous_page: number;
    total_pages: number;
    total_items: number;
    private latestQueryParams: any = {};
    sortColumn: string = null;
    sortOrder: 'asc' | 'desc' = null;

    public pageSizeControl = new FormControl(10);
    public pageRecordOptions = [
        { value: '10', label: '10' },
        { value: '25', label: '25' },
        { value: '50', label: '50' },
        { value: '100', label: '100' },
        { value: '200', label: '200' },
    ];
    public statusList = [
        { id: '1', name: 'Active' },
        { id: '0', name: 'Inactive' },
    ];

    public rolesList = []
    public rolesbyTypeList = []
    public filterUserType: number | null = null;
    public filterRole: number | null = null;
    public filterRolesList = [];
    public isDownloading = false

    modalRef: NgbModalRef | null = null;
    userList: FormGroup;
    userEditForm: FormGroup;
    viewUserForm: FormGroup;
    emailAlreadyExists: boolean = false;

    userName: any;
    userEmail: any;
    userProfile: UserProfile;

    user: Users[];
    selectedUser: Users;
    @ViewChild('myTable') table: any;
    selectedCars: number[] = [];
    dataSource: Users;
    rows: any[] = [];
    row: Users[] = [];

    USerID: number;
    LinkPlantU: LinkPlantUser = {
        station_id: [],
        user_id: 0
    };
    removeLinkPlantList: RemoveLinkUser = {
        station_id: 0,
        user_id: 0
    };
    expandedElement: Users;
    allPlantList: PlantList;
    linkPlant: FormGroup;
    list: any;
    searchSubject: Subject<string> = new Subject();


    PlantByUserlist: PlantByUser;
    message: any;
    loader: boolean = false
    // Separate from `loader`: this one is scoped to the table, so a filter,
    // a search keystroke or a page change no longer blanks the whole page.
    tableLoader: boolean = false;
    activeTab: 'contract' | 'region' = 'contract';
    selectedPlants: TreeStations[] = [];
    contractTree: TreeStations[] = [];
    regionTree: TreeStations[] = [];
    selectAllContractExpanded: boolean = true;
    selectAllContractChecked: boolean = false;
    selectAllRegionsExpanded: boolean = true;
    selectAllRegionsChecked: boolean = false;
    permissions = { ...DEFAULT_PERMISSIONS };
    permissionsReady: boolean = false;
    ngOnInit(): void {
        this.initComponent()
        // this.fetchRolesDropdown();
        // this.fetchUserTypeDropdown();
        // this.linkPlant = this.formBuilders.group({
        //     plantName: new FormControl(null, Validators.required)
        // });
        // this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
        //     this.searchElement = searchTerm;
        //     this.updateQueryParams({ search: this.searchElement });
        // });
        // this.getTableData();
        // this.plants();
    }
    async initComponent() {
  this.loader=true
        await this.getComponentPermissions();

        this.fetchRolesDropdown();
        this.fetchUserTypeDropdown();
        this.linkPlant = this.formBuilders.group({
            plantName: new FormControl(null, Validators.required)
        });
        this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
            this.searchElement = searchTerm;
            this.updateQueryParams({ search: this.searchElement });
        });
        if (this.permissions.canView) {
            this.getTableData();
            this.plants();
        }
        setTimeout(() => {
            this.loader = false;
        }, 250);
    }
    async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
    get hasAnyActionPermission(): boolean {
        return (
            this.permissionsReady &&
            (this.permissions.canView ||
                this.permissions.canEdit ||
                this.permissions.canDelete)
        );
    }

    showSuccess(message: string) {
        this.toaster.success(message);
    }

    showError(message: string) {
        this.toaster.error(message);
    }

    sortUsers(column: string): void {
        if (this.sortColumn === column) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortColumn = column;
            this.sortOrder = 'asc';
        }

        let sortValue: string | null = null;
        let columnName: string;

        if (this.sortOrder === 'asc') {
            sortValue = '0';
        } else if (this.sortOrder === 'desc') {
            sortValue = '1';
        }

        switch (column) {
            case 'username':
                columnName = 'username';
                break;
            default:
                columnName = column;
                break;
        }

        this.updateQueryParams({ sort: sortValue, column: columnName });
    }

    private updateQueryParams(paramsToUpdate: any): void {
        this.latestQueryParams = {
            ...this.latestQueryParams,
            ...paramsToUpdate
        };
        console.log('Updated queryParams:', this.latestQueryParams);

        if (this.latestQueryParams.search === '') {
            this.latestQueryParams.search = null;
        }
        if (this.latestQueryParams.page === 1) {
            this.latestQueryParams.page = null;
        }
        if (this.latestQueryParams.size === 10) {
            this.latestQueryParams.size = null;
        }

        ['sort', 'column', 'user_type', 'role', 'status'].forEach(key => {
            if (this.latestQueryParams[key] === null) {
                delete this.latestQueryParams[key];
            }
        });

        if (paramsToUpdate.search !== undefined || paramsToUpdate.size !== undefined) {
            this.latestQueryParams = {
                ...this.latestQueryParams,
                size: paramsToUpdate.size ?? this.latestQueryParams.size,
                search: paramsToUpdate.search ?? this.latestQueryParams.search,
                page: paramsToUpdate.page ?? 1
            };
        }
        this.getTableData();
    }

    private getTableData(): void {
        const name = this.latestQueryParams['search'] || this.searchElement;
        console.log('name search', name);
        const page = this.latestQueryParams['page'] ? +this.latestQueryParams['page'] : 1;
        console.log('current Page', page);
        const size = this.latestQueryParams['size'] ? +this.latestQueryParams['size'] : 10;
        const sort = this.latestQueryParams['sort'] || null;
        const column = this.latestQueryParams['column'] || null;
        const user_type = this.latestQueryParams['user_type'] || null;
        const role = this.latestQueryParams['role'] || null;
        const status = this.latestQueryParams['status'] || null;
        this.getAllUsers(name, page, size, sort, column, user_type, role, status);
    }


    getAllUsers(
        name: string,
        page: number,
        size: number,
        sort: string | null,
        column: string | null,
        user_type: number,
        role: number | null,
        status: number | null
    ): void {
        this.tableLoader = true;
        this.row = [];
        this.serialNumberArray = [];

        this._utiltiySevice
            .receiveAllUsers(name, page, size, sort, column, user_type, role, status)
            .pipe(
                finalize(() => {
                    this.tableLoader = false;
                })
            )
            .subscribe({
                next: (res: any) => {
                    if (res?.status === 200) {
                        this.row = res.data.map((ticket: any, index: number) => ({
                            ...ticket,
                            srNo: (res.current_page - 1) * size + index + 1
                        }));

                        this.current_page = res.current_page;
                        this.next_page = res.next_page;
                        this.previous_page = res.previous_page;
                        this.total_pages = res.total_pages;
                        this.total_items = res.total_users;

                        this.enablePagination();
                    } else {
                        // Handle API-level error response
                        console.error('Unexpected response:', res);
                    }
                },
                error: (err) => {
                    console.error('Error fetching users:', err);

                    let errorMessage = 'Failed to load users';

                    // Backend returns error message
                    if (err?.error?.message) {
                        errorMessage = err.error.message;
                    }
                    // Laravel / API validation errors
                    else if (err?.error?.error) {
                        errorMessage = err.error.error;
                    }
                    // Network / server error
                    else if (err?.message) {
                        errorMessage = err.message;
                    }

                    this.toaster.error(errorMessage);

                    // Optional: reset pagination/data
                    this.row = [];
                }
            });
    }


    public searchData(event: Event): void {
        this.searchElement = (event.target as HTMLInputElement)?.value || '';
        console.log('search Value', this.searchElement);
        this.searchSubject.next(this.searchElement);
    }

    goToPage(page: number): void {
        console.log('move to page', page);
        if (page >= 1 && page <= this.total_pages) {
            this.updateQueryParams({ page: page });
        }
    }

    navigatePage(direction: string): void {
        if (direction === 'prev' && this.current_page > 1) {
            this.goToPage(this.current_page - 1);
        } else if (direction === 'next' && this.next_page !== null) {
            this.goToPage(this.current_page + 1);
        }
    }

    navigateToPage(): void {
        if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
            this.goToPage(this.pageToGo);
        }
    }

    public changePageSize(): void {
        this.pageSize = this.pageSizeControl.value!;
        this.updateQueryParams({ size: this.pageSize })
    }
    // Modify the selectTypelistStatus method
    public selectTypelistStatus(selectedTypeId) {
        this.filterUserType = selectedTypeId;
        this.filterRole = null; // Reset filter role when type changes

        if (selectedTypeId) {
            // Fetch roles for the selected type (for filter only)
            this.fetchFilterRolesBasedOnType(selectedTypeId);
        } else {
            // If no type selected, show all roles
            this.filterRolesList = this.rolesList;
        }

        this.updateQueryParams({ user_type: selectedTypeId, role: null });
    }
    // public selectTypelistStatus(selectedTypeId) {
    //     this.filterUserType = selectedTypeId;
    //     this.filterRole = null; // Reset filter role when type changes
    //     this.filterRolesList = []; // Clear filter roles list

    //     if (selectedTypeId) {
    //         // Fetch roles for the selected type (for filter only)
    //         this.fetchFilterRolesBasedOnType(selectedTypeId);
    //     }

    //     this.updateQueryParams({ user_type: selectedTypeId, role: null });
    // }

    public selectRoleslistStatus(selectedRoleId) {
        this.filterRole = selectedRoleId;
        this.updateQueryParams({ role: selectedRoleId });
    }

    // Add new method for filter roles
    fetchFilterRolesBasedOnType(id: number): void {
        this._utilityService.getUserRoleByType(id).subscribe((res) => {
            if (res) {
                this.filterRolesList = res;
            }
        });
    }
    public selecttStatus(status) {
        this.updateQueryParams({ status: status });
    }

    onSort(event: any): void {
        const sortBy = event.sorts[0];

        this.row.sort((a, b) => {
            const valueA = a[sortBy.prop];
            const valueB = b[sortBy.prop];

            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return sortBy.dir === 'asc' ? valueA - valueB : valueB - valueA;
            } else if (
                typeof valueA === 'string' &&
                typeof valueB === 'string'
            ) {
                return sortBy.dir === 'asc'
                    ? valueA.localeCompare(valueB)
                    : valueB.localeCompare(valueA);
            } else {
                return String(valueA).localeCompare(String(valueB));
            }
        });
    }

    closeModal() {
        if (this.modalRef) {
            this.modalRef.close('Closed');
        }
        this.selectedUser = null
        this.selectedUserId = null
    }

    resetForm() {
        this.userList.reset();
        this.userEditForm.reset();
        this.viewUserForm.reset();
        this.USerID = null;
        this.rolesbyTypeList = [];
        // Reset is_active to true by default
        this.userList.patchValue({ is_active: true });
        // this.userEditForm.patchValue({ is_active: true });
    }

    addUser(user: any) {
        this.modalRef = this.modalService.open(user, { centered: true, size: 'lg' });

        if (this.modalRef) {
            this.modalRef.hidden.subscribe((result) => {
                this.resetForm();
            });
        }
    }

    open(content: any, row: Users) {
        this.selectedUser = row;
        console.log(this.selectedUser);
        this.selectedCars = [];
        this.modalRef = this.modalService.open(content, { centered: true, size: 'lg' });
        this.USerID = row.user_id;

        const type = this.userTypelist.find(r => r.id === row.user_type_id);

        if (type && type.id) {
            this.fetchRolesBasedOnTypeDropdown(type.id);
        }

        this.userEditForm.patchValue({
            full_name: row.name,
            contact: row.contact,
            username: row.username,
            email: row.email,
            employee_id: row.employee_id || '',
            cnic: row.cnic || '',
            user_type: row.user_type_id || null,
            role: row.role_id || null,
            is_active: row.is_active || false
        });
    }
    view(content: any, row: Users) {
        this.selectedUser = row;
        this.selectedCars = [];
        this.modalRef = this.modalService.open(content, { centered: true, size: 'lg' });
        this.USerID = row.user_id;

        // Corrected: Match based on `role_id` instead of `account_type`
        const type = this.userTypelist.find(r => r.id === row.user_type_id);
        if (type && type.id) {
            this.fetchRolesBasedOnTypeDropdown(type.id);
        }

        this.viewUserForm.patchValue({
            full_name: row.name,
            contact: row.contact,
            username: row.username,
            email: row.email,
            employee_id: row.employee_id || '',
            cnic: row.cnic || '',
            user_type: type ? type.id : null, // Ensure correct match for `user_type_id`
            role: row.role || null,         // Ensure correct match for `role_id`
            is_active: row.is_active || false
        });
    }

    // view(content: any, row: Users) {
    //     this.selectedUser = row;
    //     this.selectedCars = [];
    //     this.modalRef = this.modalService.open(content, { centered: true, size: 'lg' });
    //     this.USerID = row.user_id;

    //     const role = this.userTypelist.find(r => r.account_type === row.role);

    //     this.viewUserForm.patchValue({
    //         full_name: row.name,
    //         contact: row.contact,
    //         username: row.username,
    //         email: row.email,
    //         employee_id: row.employee_id || '',
    //         cnic: row.cnic || '',
    //         user_type: role ? role.id : null,
    //         role: row.role_id || null,
    //         // is_active: row.is_active
    //     });
    // }

    showLink(link: any, row: Users) {
        this.modalService.open(link, { windowClass: 'complainModelClass' });
        var userInlist = row.user_id;
        this.table.rowDetail.toggleExpandRow(row);
        this._utilityService.showLinkPlant(userInlist).subscribe((res) => {
            if (res) {
                this.PlantByUserlist = res.data;
            }
        });
    }

    getUser() {
        this._utilityService.receiveUser().subscribe((res) => {
            if (res) {
                var response = res;
                console.log('response', response)
                this.setExtraData(res);
            }
        });
    }

    FiltergetUser(filter: string, filterType: string) {
        this._utilityService.receiveUserFilter(filterType + "=" + filter).subscribe((res) => {
            if (res) {
                var response = res;
                this.setExtraData(res);
            }
        });
    }

    setExtraData(response: any) {
        var totalCount = response.total_users;
        console.log('setExtraData', totalCount)
        var totalPages = response.total_pages;
        var currentPage = response.current_page;
        var rowIndex = 0;
        this.row = [];
        for (var i = 1; i <= totalPages; i++) {
            for (var k = 0; k < 10; k++, rowIndex++) {
                if (rowIndex < response.total_users) {
                    this.row.push(response.data[k]);
                }
                else {
                    break;
                }
            }
        }
    }

    usersPageChange(event: any) {
        var newPage = parseInt(event.offset) + 1;
        console.log('usersPageChange', newPage)
        this.FiltergetUser(event.offset + 1, 'page');
    }

    Search() {
        if (this.userName == '') {
            this.ngOnInit();
        } else {
            console.log('inside search function')
            this.row = this.row.filter((res) => {
                return res.username
                    ?.toLocaleLowerCase()
                    .match(this.userName?.toLocaleLowerCase());
            });
        }
    }

    searchByEmail() {
        if (this.userEmail == '') {
            this.ngOnInit();
        } else {
            this.row = this.row.filter((res) => {
                return res.email
                    ?.toLocaleLowerCase()
                    .match(this.userEmail?.toLocaleLowerCase());
            });
        }
    }

    toggleExpandRow(row) { }
    listInfo(row) {
        this.toggleExpandRow(row);
    }
    onDetailToggle(event) { }

    plants() {
        this._utilityService.PlantsdetailsAll().subscribe((res) => {
            if (res) {
                this.allPlantList = res.data;
            }
        });
    }

    onMaterialGroupChange() {
        this.list = this.selectedCars;
    }

    linkUserList() {
        this.LinkPlantU.station_id = this.selectedCars;
        this.LinkPlantU.user_id = this.USerID;
        this._utilityService
            .linkUserPlants(this.LinkPlantU)
            .subscribe((res) => {
                if (res) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '`<h2>Plant Linked  Successfully</h2>`',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            });
    }

    removePlantLink(item: PlantByUser) {
        this.removeLinkPlantList.station_id = item.stationId;
        this.removeLinkPlantList.user_id = item.userId;
        this._utilityService.removeUserPlant(this.removeLinkPlantList).subscribe((res) => {
            if (res) {
                var userInlist = item.userId;

                this._utilityService.showLinkPlant(userInlist).subscribe((res) => {
                    if (res) {
                        this.PlantByUserlist = res.data;
                        if (res) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: '`<h2>Plant Unlinked  Successfully</h2>`',
                                showConfirmButton: false,
                                timer: 1500
                            });
                        }
                    }
                });
            }
        })
    }


    addUserAccout() {
        if (this.userList.invalid) {
            this.showError('Please fill all required fields correctly');
            Object.keys(this.userList.controls).forEach(key => {
                this.userList.get(key).markAsTouched();
            });
            return;
        }

        const formData = {
            ...this.userList.value,
            // is_active: this.userList.value.is_active ? 1 : 0
        };

        console.log('Form Data to be submitted:', formData);

        this._utiltiySevice.saveUser(formData).subscribe((res) => {
            if (res) {
                if (res.message === 'Username or Email already exists. Kindly, use another email/username.') {
                    this.emailAlreadyExists = true;
                    this.showError(res.message);
                } else {
                    this.emailAlreadyExists = false;
                    this.showSuccess(res.message);
                    this.getTableData();
                    this.closeModal();
                    this.resetForm();
                }
            }
        }, error => {
            this.showError('Failed to add user. Please try again.');
            console.error('Error adding user:', error);
        });
    }

    UpdateUserAccout() {
        if (this.userEditForm.invalid) {
            this.showError('Please fill all required fields correctly');
            Object.keys(this.userEditForm.controls).forEach(key => {
                this.userEditForm.get(key).markAsTouched();
            });
            return;
        }

        const formData = {
            ...this.userEditForm.getRawValue(),
            // is_active: this.userEditForm.value.is_active ? 1 : 0
        };

        console.log('Update Form Data:', formData);

        this._utiltiySevice.updateUser(this.USerID, formData).subscribe({
            next: (res: any) => {
                if (res) {
                    this.showSuccess(res.message);
                    this.getTableData();
                    this.closeModal();
                    this.resetForm();
                }
            },
            error: (err) => {
                console.error('Update failed:', err);
                this.showError('Failed to update user. Please try again later.');
            }
        });
    }

    disableUser(userId) {
        this.disableUserPopup(userId);
    }

    openDelModal(id: number, content: any) {
        this.modalService.open(content, { centered: true }).result.then(
            (result) => {
                if (result === 'confirm') {
                    this._utiltiySevice.disableUserApi(id).subscribe((res) => {
                        if (res) {
                            console.log("Success");
                            this.row.filter(item => item.user_id === id)[0].is_active = false;
                        }
                    })
                    this.toaster.success('User has been inactive')
                    this.getTableData();
                }
            },
            (reason) => {
                console.log('Modal dismissed:', reason);
            }
        );
    }

    disableUserPopup(userId) {
        Swal.fire({
            title: 'Are you sure you want to disable this User?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#FB8C04',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, disable it!'
        }).then((result) => {
            if (result.isConfirmed) {
                this._utiltiySevice.disableUserApi(userId).subscribe((res) => {
                    if (res) {
                        console.log("Success");
                        this.row.filter(item => item.user_id === userId)[0].is_active = false;
                    }
                })
                Swal.fire(
                    'Disabled!',
                    'user has been disabled.',
                    'success'
                )
                this.getTableData();
            }
        })
    }

    enablePagination() {
        const linkElement = document.getElementById('prevPage');

        if (this.previous_page === null) {
            linkElement.setAttribute('disabled', 'true');
            linkElement.style.pointerEvents = 'none';
            linkElement.style.color = 'gray';
            linkElement.addEventListener('click', (event) => {
                event.preventDefault();
            });
        } else {
            linkElement.removeAttribute('disabled');
            linkElement.style.pointerEvents = 'auto';
            linkElement.style.color = '';
            linkElement.removeEventListener('click', (event) => {
                event.preventDefault();
            });
        }
    }

    fetchPlantsTree(row: any, content: any): void {
        this.selectedUser = row
        this.selectedUserId = row.user_id
        this._utilityService.getPlantsTree(this.selectedUserId).pipe(
            tap((response: any) => {
                if (response) {
                    this.fetchData(response)
                    this.modalRef = this.modalService.open(content, { centered: true, size: 'xl', windowClass: 'association-modal' })
                }
            }),
            catchError((error: HttpErrorResponse) => {
                console.log('error', error.error.message);
                return of(undefined);
            })
        ).subscribe();
    }

    fetchData(apiResponse: any): void {
        const contractGroup = apiResponse.data.contract_type_group;
        const regionGroup = apiResponse.data.region_group;

        this.selectedPlants = [];

        const addSelectedPlant = (station: TreeStations) => {
            if (!this.selectedPlants.some(p => p.stationId === station.stationId)) {
                this.selectedPlants.push(station);
            }
        };

        this.contractTree = Object.keys(contractGroup).map(type => ({
            name: type,
            selected: false,
            expanded: contractGroup[type]?.length > 0,
            selectable: false,
            children: contractGroup[type].map((station: any): TreeStations => {
                const node: TreeStations = {
                    name: station.stationName,
                    selected: station.is_associated,
                    stationId: station.stationId,
                    stationCode: station.stationCode,
                    is_associated: station.is_associated,
                    selectable: true
                };
                if (station.is_associated) {
                    addSelectedPlant(node);
                }
                return node;
            })
        }));

        this.regionTree = Object.keys(regionGroup).map(regionName => {
            const cities = regionGroup[regionName];
            const cityNodes = Object.keys(cities).map(cityName => {
                const stations = cities[cityName];
                return {
                    name: cityName,
                    selected: false,
                    expanded: stations?.length > 0,
                    selectable: false,
                    children: stations.map((station: any): TreeStations => {
                        const node: TreeStations = {
                            name: station.stationName,
                            selected: station.is_associated,
                            stationId: station.stationId,
                            stationCode: station.stationCode,
                            is_associated: station.is_associated,
                            selectable: true
                        };
                        if (station.is_associated) {
                            addSelectedPlant(node);
                        }
                        return node;
                    })
                };
            });

            return {
                name: regionName,
                selected: false,
                expanded: cityNodes?.length > 0,
                selectable: false,
                children: cityNodes
            };
        });
    }

    toggleGroup(group: TreeStations): void {
        group.expanded = !group.expanded;
    }

    addSelectedPlants(): void {
        const selectedFromContract = this.getSelectedNodes(this.contractTree);
        const selectedFromRegion = this.getSelectedNodes(this.regionTree);

        const selectedMap = new Map();

        [...selectedFromContract, ...selectedFromRegion].forEach(station => {
            selectedMap.set(station.stationId, { ...station });
        });

        this.selectedPlants = Array.from(selectedMap.values());
    }

    removePlant(stationId: number): void {
        this.selectedPlants = this.selectedPlants.filter(p => p.stationId !== stationId);
    }

    getSelectedNodes(nodes: TreeStations[]): TreeStations[] {
        let selected: TreeStations[] = [];

        for (const node of nodes) {
            if (node.selected && node.stationId) {
                selected.push(node);
            }

            if (node.children?.length) {
                selected.push(...this.getSelectedNodes(node.children));
            }
        }

        return selected;
    }

    onStationChange(parent: TreeStations): void {
        const children = parent.children || [];
        const allSelected = children.length > 0 && children.every(child => child.selected);

        if (children.length === 1 && allSelected) {
            parent.selected = true;
        } else if (!allSelected) {
            parent.selected = false;
        }
    }

    toggleGroupSelection(parent: TreeStations): void {
        const isSelected = parent.selected;
        (parent.children || []).forEach(child => {
            child.selected = isSelected;
            if (child.children?.length) {
                this.toggleGroupSelection(child);
            }
        });
    }

    hasNonEmptyChildren(node: TreeStations): boolean {
        return !!node.children?.some(child => child.selectable || this.hasNonEmptyChildren(child));
    }

    selectAllContracts(): void {
        const shouldSelectAll = this.selectAllContractChecked;

        this.contractTree.forEach(parent => {
            parent.selected = shouldSelectAll;
            this.toggleGroupSelection(parent);
        });
    }

    selectAllRegions(): void {
        const shouldSelectAll = this.selectAllRegionsChecked;

        this.regionTree.forEach(region => {
            region.selected = shouldSelectAll;
            this.toggleGroupSelection(region);
        });
    }

    toggleSelectAllContract(): void {
        this.selectAllContractExpanded = !this.selectAllContractExpanded;
    }

    updateSelectAllCheckboxState(): void {
        const allSelected = this.contractTree.every(contract =>
            contract.selected || !this.hasNonEmptyChildren(contract)
        );
        this.selectAllContractChecked = allSelected;
    }

    toggleSelectAllRegions(): void {
        this.selectAllRegionsExpanded = !this.selectAllRegionsExpanded;
    }

    updateSelectAllRegionsCheckboxState(): void {
        const allSelected = this.regionTree.every(region =>
            region.selected || !this.hasNonEmptyChildren(region)
        );
        this.selectAllRegionsChecked = allSelected;
    }

    getSelectedStationIds(plants: TreeStations[]): number[] {
        let ids: number[] = [];
        for (const plant of plants) {
            if (plant.selected && plant.stationId) {
                ids.push(plant.stationId);
            }
            if (plant.children?.length) {
                ids = ids.concat(this.getSelectedStationIds(plant.children));
            }
        }
        return ids;
    }

    resetContractSelection(): void {
        this.contractTree.forEach(contract => {
            contract.selected = false;
            if (contract.children && contract.children.length > 0) {
                contract.children.forEach(station => {
                    station.selected = false;
                });
            }
        });

        this.selectAllContractChecked = false;
    }

    resetRegionSelection(): void {
        this.regionTree.forEach(region => {
            region.selected = false;
            if (region.children && region.children.length > 0) {
                region.children.forEach(city => {
                    city.selected = false;
                    if (city.children && city.children.length > 0) {
                        city.children.forEach(station => {
                            station.selected = false;
                        });
                    }
                });
            }
        });

        this.selectAllRegionsChecked = false;
    }

    resetPlantSelection(): void {
        this.selectedPlants = [];
    }

    resetAllSelections(): void {
        this.resetContractSelection();
        this.resetRegionSelection();
        this.resetPlantSelection();
    }

    resetAndCollapseAll(): void {
        this.resetAllSelections();

        this.selectAllContractExpanded = false;
        this.selectAllRegionsExpanded = false;

        this.contractTree.forEach(contract => {
            contract.expanded = false;
        });

        this.regionTree.forEach(region => {
            region.expanded = false;
            if (region.children && region.children.length > 0) {
                region.children.forEach(city => {
                    city.expanded = false;
                });
            }
        });
    }

    onApply() {
        if (!this.selectedUserId) {
            this.toaster.error('Please select a user before applying.');
            return;
        }

        const stationIds = this.getSelectedStationIds(this.selectedPlants);

        if (stationIds.length === 0) {
            this.toaster.error('Please select at least one station.');
            return;
        }

        const payload = {
            user_id: this.selectedUserId,
            station_ids: stationIds
        };
        this.resetAllSelections()

        this._utilityService.updateUserPlantAssociation(payload).pipe(
            catchError(error => {
                if (error.status === 400) {
                    this.toaster.error(error.error.message);
                    this.resetForm();
                } else {
                    this.toaster.error('Something went wrong while updating the city association. Please try again later.');
                    this.resetForm();
                }
                return throwError(error);
            })
        ).subscribe(response => {
            if (response && response.status === 200) {
                this.getTableData();
                this.resetAllSelections()
                this.closeModal()
                this.toaster.success('Plant association updated successfully!');
            }
        });
    }

    resetPassword(email: string, content: any) {
        this.modalService.open(content, { centered: true }).result.then(
            (result) => {
                if (result === 'confirm') {
                    if (email) {
                        const payload = { email: email }
                        this._utilityService.resetUserPassword(payload).pipe(
                            catchError(error => {
                                if (error.status === 400) {
                                    this.toaster.error(error.error.message || 'Bad request');
                                } else {
                                    this.toaster.error('An error occurred. Please try again later.');
                                }
                                this.resetForm();
                                return throwError(() => error);
                            })
                        ).subscribe(() => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Password reset successfully',
                                showConfirmButton: false,
                                timer: 1000
                            });
                            this.getTableData();
                        });
                    }
                }
            },
            (reason) => {
                console.log('Modal dismissed:', reason);
            }
        );
    }

    fetchUserTypeDropdown() {
        this._utilityService.getUserTypesHierarchyDropdown().subscribe((res) => {
            if (res) {
                this.userTypelist = res;
                console.log(this.userTypelist)
            }
        });
    }

    fetchRolesDropdown(): void {
        this._utilityService.getUserRole().subscribe((res) => {
            if (res) {
                this.rolesList = res;
                this.filterRolesList = res;
            }
        });
    }

    onUserTypeChange(typeId: number): void {
        this.userList.patchValue({ role: null });
        this.rolesbyTypeList = [];

        if (typeId) {
            this.fetchRolesBasedOnTypeDropdown(typeId);
        }
    }

    onUserTypeChangeEdit(typeId: number): void {
        this.userEditForm.patchValue({ role: null });
        this.rolesbyTypeList = [];

        if (typeId) {
            this.fetchRolesBasedOnTypeDropdown(typeId);
        }
    }

    fetchRolesBasedOnTypeDropdown(id: number): void {
        this._utilityService.getUserRoleByType(id).subscribe((res) => {
            if (res) {
                this.rolesbyTypeList = res;
                console.log('Roles for type', id, ':', this.rolesbyTypeList);
            }
        });
    }
    downloadReport(): void {
        const user_type = this.latestQueryParams['user_type'] || null;
        const role = this.latestQueryParams['role'] || null;
        const status = this.latestQueryParams['status'] || null;
        const search = this.latestQueryParams['search'] || null;
        const sort = this.latestQueryParams['sort'] || null;
        const column = this.latestQueryParams['column'] || null;

        this.isDownloading = true;  // start loader

        const payload = {
            user_type: user_type,
            role: role,
            is_active: status,
            search: search,
            sort: sort,
            column: column
        };

        this._utilityService
            .downloadUsersReport(payload)
            .subscribe({
                next: (res: Blob) => {
                    const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;

                    // Generate timestamp for filename
                    const now = new Date();
                    const year = now.getFullYear();
                    const month = String(now.getMonth() + 1).padStart(2, '0');
                    const day = String(now.getDate()).padStart(2, '0');
                    const hours = String(now.getHours()).padStart(2, '0');
                    const minutes = String(now.getMinutes()).padStart(2, '0');
                    const seconds = String(now.getSeconds()).padStart(2, '0');

                    const timestamp = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
                    a.download = `Users_Export_${timestamp}.xlsx`;

                    a.click();
                    window.URL.revokeObjectURL(url);
                    this.isDownloading = false; // stop loader
                    this.closeModal();
                    this.resetForm();
                },
                error: () => {
                    this.isDownloading = false; // stop loader on error
                    this.toaster.error('Failed to download report. Please try again.');
                }
            });
    }
}